<template lang="pug">
  router-link(
    :to="route"
    @mouseover.native="hover"
    @mouseleave.native="blur"
    class="table_row"
  )
    .table_small.type
      .table_cell Weinsorte
      .table_cell 
        svg(
          v-if="propertyValues['weinsorte']"
          aria-hidden="true" 
          role="img" 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 288 512"
          class="svg-inline--fa fa-wine-glass-alt"
          :class="propertyValues['weinsorte'].values[0]"
          )
            title {{ propertyValues['weinsorte'].values[0] }}
            g.fa-group
              path.fa-secondary(
                fill="currentColor"
                d="M64.38,198.37,70.69,128H217.36l6.3,70.36a79.63,79.63,0,0,1-15.28,55.26,81,81,0,0,1-46.83,30.85,77.47,77.47,0,0,1-35,0,81,81,0,0,1-46.83-30.85,79.76,79.76,0,0,1-15.35-55.25Z"
              )
              path.fa-primary(
                fill="currentColor"
                d="M211.63,64l12,134.36a79.63,79.63,0,0,1-15.28,55.26,81,81,0,0,1-46.83,30.85,77.47,77.47,0,0,1-35,0A81,81,0,0,1,79.7,253.62a79.76,79.76,0,0,1-15.29-55.26L76.42,64H211.63M255.74,0H32.31a15.85,15.85,0,0,0-15.7,14.55L.61,192.66A144.67,144.67,0,0,0,112,346.82V464H72a40,40,0,0,0-40,40,8,8,0,0,0,8,8H248a8,8,0,0,0,8-8,40,40,0,0,0-40-40H176V346.81A144.67,144.67,0,0,0,287.39,192.65l-16-178.1A15.85,15.85,0,0,0,255.74,0Z"
              )
    .table_small.year
      .table_cell Jahr
      .table_cell {{ propertyValues['jahr'].values[0] | parseInt }}
   
    .table_small.liter 
      .table_cell Liter
      .table_cell {{ propertyValues['liter'].values[0] | parseFloat }}
    
    .table_small.wine 
      .table_cell Wein
      .table_cell {{ teaser.name }}

    .table_small.region 
      .table_cell Region / Erzeuger
      .table_cell {{ propertyValues['region-erzeuger'].values[0]}}

    .table_small.points 
      .table_cell Punkte
      .table_cell(v-if="propertyValues['punkte']") {{ propertyValues['punkte'].values[0] | parseInt }}RP

    .table_small.info 
      .table_cell Info*
      .table_cell(v-html="striptags(teaser.description)")

    .table_small.img
      .table_cell Bild
      .table_cell 
        popper(v-if="image" trigger='hover' :options="{placement: 'left',modifiers: { offset: { offset: '0,15px' } }}")
          .popper
            img( v-lazy="image", :title="teaser.name",:style="{ width: '100%', height: 'auto' }")
            .title {{ teaser.name }}
          button(slot='reference')
            font-awesome-icon(icon="camera")
    
    .table_small.qty
      .table_cell Fl.
      .table_cell {{ teaser.qty_sum }}

    .table_small.price
      .table_cell €/Fl.
      .table_cell(v-html="price")
    
    .table_small.pa
      .table_cell Info
      .table_cell !

    .table_small.addToCart
      .table_cell Warenkorb
      .table_cell
        .add-to-cart(v-if="possibleConfigurations === 1")
          button(@click.stop.prevent="addToCart" :disabled="fetching") hinzufügen
            font-awesome-icon(icon="shopping-cart")
        .details-button(v-else)
          button Info
            font-awesome-icon(icon="shopping-cart")

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import striptags from 'striptags';
import VanillaTilt from 'vanilla-tilt';
import Popper from 'vue-popperjs';
import uniqid from 'uniqid';

import { get, trim } from '@/helpers';
import { getPropertyValues } from '@/extensions/shop/helpers';

import { moneyFormat, findPrice } from '@/filters';

import TeaserProperty from './TeaserProperty';

export default {
    name: 'Teaser',
    data() {
        return {
            loading: false,
            delay: 150,
            mouseover: false,
            fetching: false
            // stars: 5,
        };
    },
    props: {
        teaser: {
            type: Object,
            required: true
        },
        display: {
            type: String,
            default: 'card',
            validator: val => ['row', 'card', 'tile'].includes(val)
        }
    },
    components: {
        TeaserProperty,
        popper: Popper
    },
    filters: {
        parseInt: value => parseInt(value),
        parseFloat: value => parseFloat(value)
    },
    computed: {
        route() {
            return {
                name: 'product-details',
                params: {
                    product: this.teaser.slug
                }
            };
        },

        price() {
            const defaultCustomerGroup = get(this.cms, 'shop.defaultCustomerGroup');
            const price = findPrice(this.teaser, null, defaultCustomerGroup, true);

            const code = get(defaultCustomerGroup, 'currency.iso4217') || 'EUR';

            return moneyFormat(price.value, code);
        },
        properties() {
            const properties = [];
            const propertyPivots = this.teaser.propertyPivots || [];

            propertyPivots.forEach(propertyPivot => {
                if (propertyPivot.property.visible_on_product_listing === true) {
                    const values = propertyPivot.values.map(el => {
                        return {
                            value: el[propertyPivot.property.propType.value_field],
                            value_alt: el[propertyPivot.property.propType.value_field_alt]
                        };
                    });
                    properties.push({
                        key: propertyPivot.property.key,
                        name: propertyPivot.property.name,
                        type: propertyPivot.property.propType.key,
                        values
                    });
                }
            });

            return properties;
        },
        propertyValues() {
            let values = {};
            this.teaser.propertyPivots.forEach(pivot => {
                // values.push(getPropertyValues(pivot))
                const key = pivot?.property?.key;
                values[key] = getPropertyValues(pivot);
            });
            return values;
        },
        possibleConfigurations() {
            let numberOfConfigurations = 1;
            const propertyPivots = this.teaser.propertyPivots || [];
            propertyPivots.forEach(pivot => {
                const el = getPropertyValues(pivot);
                numberOfConfigurations *= el?.values?.length || 1;
            });
            return numberOfConfigurations;
        },

        image() {
            let image;

            if (
                this.teaser.media &&
                this.teaser.media.type === 'image' &&
                typeof this.teaser.media.image === 'object'
            ) {
                let data = this.teaser.media.image;

                const storageRoute = trim(
                    `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
                    '/'
                );

                let { method } = get(data, 'settings') || {};
                const { width, height } = data;
                let aspectRatio = width / height;

                const defaultWidth = get(this.teaser, 'style.width', 250);
                let w = Math.min(width, defaultWidth + 1);

                const defaultheight = get(this.teaser, 'style.height') ? this.teaser.style.height - 70 : 300;
                let h = Math.min(height, defaultheight + 1);

                if (aspectRatio > 1) {
                    // landscape
                    // limit by width
                    h = w / aspectRatio;
                } else if (aspectRatio < 1) {
                    // portrait
                    // limit by height
                    w = h * aspectRatio;
                }

                let fit = `fit&w=${w}&h=${h}`;

                if (method) {
                    // TODO
                    // put together a fit statement with correct max width and height
                    // let { crop, x, y, z } = get(data, 'settings') || {};
                }

                image = {
                    src: `${storageRoute}/images/${data.id}/${data.name}?${fit}`,
                    error: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=greyscale`,
                    loading: `${storageRoute}/images/${data.id}/${data.name}?${fit}&preview=blur`,
                    width: w,
                    height: h,
                    aspectRatio
                };
            }

            return image;
        },
        style() {
            let style;
            if (this.display === 'tile' && this.teaser.style) {
                style = {
                    position: 'absolute',
                    display: 'flex',
                    left: `${this.teaser.style.left}px`,
                    top: `${this.teaser.style.top}px`,
                    width: `${this.teaser.style.width}px`,
                    height: `${this.teaser.style.height}px`
                };
            }
            return style;
        },
        clamp() {
            let clamp = 3;
            if (this.ratings && this.ratings.length) clamp = 2;
            return clamp;
        },
        ...mapGetters({
            cms: 'CMS'
        })
    },
    methods: {
        hover() {
            this.$emit('focus', this.item);
            this.mouseover = true;
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item);
                this.mouseover = false;
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />');
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br']);
        },
        addToCart() {
            // TODO:
            // get articles by product id
            // if there is only one article
            // then add to cart, otherwise open details

            this.fetching = true;
            this.fetchProduct({ id: parseInt(this.teaser.id) })
                .then(product => {
                    if (product?.articles?.length === 1) {
                        const article = product.articles[0];
                        try {
                            this.addArticleToCart({ article, qty: 1 });

                            const text = `
                <p>Der folgende Artikel wurde Ihrem Warenkorb hinzugefügt</p>
                <blockquote class="mt-2 pl-3 border-l-2 border-white border-opacity-50">
                  <h4 class="text-xl leading-none mb-1">${article.name || product.name}</h4>
                  <p class="text-xs mb-2 text-white text-opacity-75">#${product.nr}</p>
                  <p>Preis: ${this.price}</p>
                </blockquote>
              `;

                            const message = {
                                id: uniqid(),
                                text,
                                type: 'success',
                                autoclose: 4000
                            };
                            this.addMessage(message);
                        } catch (e) {
                            const errorMessage = {
                                id: uniqid(),
                                title: 'Fehler',
                                text: 'Es gibt ein technisches Problem.',
                                type: 'error',
                                autoclose: 8000
                            };
                            this.addMessage(errorMessage);
                            this.$router.push(this.route);
                        }
                    } else {
                        this.$router.push(this.route);
                    }
                })
                .finally(() => {
                    this.fetching = false;
                });
        },
        ...mapActions({
            addMessage: 'message/add',
            addArticleToCart: 'shop/addArticleToCart',
            fetchProduct: 'shop/fetchProduct'
        })
    },
    mounted() {
        if (this.display === 'tile') {
            VanillaTilt.init(this.$refs.container, {
                scale: 1.02,
                speed: 300,
                perspective: 6000,
                max: 5,
                glare: true,
                'max-glare': 0.5
            });
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"


.table_row
    @apply table w-full mb-8
    @screen lg
      @apply table-row m-0

    .table_small
        @apply table-row border-b border-r align-top
        @screen lg
          @apply table-cell

        padding: 6px 10px
        border-color: $maisonvin-border
        &:first-child
          @apply border-l

        .table_cell
          @apply table-cell border-b border-solid
          width: 50%
          padding: 4px 10px
          border-color: $maisonvin-border

          @screen lg
            @apply block w-full p-0 border-0

          &:nth-child(odd)
            @apply table-cell text-right font-medium
            background-color: $maisonvin-grey
            width: 40%

            @screen lg
              @apply hidden

        .popper
          @apply absolute p-2
          background-color: $maisonvin-rose
          &:after
            @apply w-0 h-0 absolute
            border-top: 10px solid transparent
            border-bottom: 10px solid transparent
            border-left: 10px solid $maisonvin-rose
            right: -10px
            margin-top: -10px
            top: 50%
            content: ''
          > img
            @apply h-auto
            width: 200px !important
            margin: 0 auto
          .title
            @apply pt-2 text-center text-white

        &.type,
        &.year,
        &.liter,
        &.pa,
        &.img,
        &.qty
          @screen lg
            @apply text-center

        &.type
          .svg-inline--fa
            @apply text-lg
            .fa-primary
              fill: $maisonvin-border
            .fa-secondary
              @apply opacity-100
          .svg-inline--fa.Weißwein
            .fa-secondary
              fill: $maisonvin-yellow
          .svg-inline--fa.Rotwein
            .fa-secondary
              fill: $maisonvin-red

        &.info
          max-width: 200px

        &.year
          @screen lg
            @apply font-semibold

        &.addToCart
          @screen lg
            @apply text-center
            width: 150px

          button
            @apply text-white rounded font-semibold px-4 leading-relaxed text-sm transition duration-300 ease-in-out
            background-color: $maisonvin-red-dark
            &:hover
              background-color: $maisonvin-red
            svg
              @apply ml-1
</style>
